import { getClientLogo } from "../oauth";
import { queryKeys } from "../queryKeys";
import { type QueryOptions, useRequest } from "./useRequest";

export const useGetClientLogo = ({
  clientId = "",
  options,
}: {
  clientId?: string;
  options?: QueryOptions<string>;
}) => {
  const fetchLogo = async () => {
    return await getClientLogo(clientId);
  };

  const { data, refetch, isFetched } = useRequest(
    queryKeys.oauth.clientLogo(clientId),
    fetchLogo,
    {
      gcTime: 9999999,
      staleTime: Infinity,
      // A missing logo returns a backend error; degrade to the placeholder
      // instead of retrying and surfacing the shared error toast.
      retry: false,
      meta: { showErrorToast: false },
      ...options,
    },
  );

  return { logo: data || "", refetch, isFetched };
};
